import { render, staticRenderFns } from "./flyerSection.component.vue?vue&type=template&id=7508867b&scoped=true&"
import script from "./flyerSection.component.vue?vue&type=script&lang=js&"
export * from "./flyerSection.component.vue?vue&type=script&lang=js&"
import style0 from "./flyerSection.component.vue?vue&type=style&index=0&id=7508867b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7508867b",
  null
  
)

export default component.exports